import { ListItemInterface } from 'components/ListingDrawer';
/*
 * Action Types
 */
export enum ListingDrawerTypes {
  SET_LISTING_DRAWER_OPEN = '@listingDrawer/SET_LISTING_DRAWER_OPEN',
  SET_LISTING_DRAWER_LIST = '@listingDrawer/SET_LISTING_DRAWER_LIST',
  SET_LISTING_DRAWER_LIST_ITEMS = '@listingDrawer/SET_LISTING_DRAWER_LIST_ITEMS',
  SET_LISTING_DRAWER_FACTORY_LIST = '@listingDrawer/SET_LISTING_DRAWER_FACTORY_LIST',
}

/*
 * State type
 */
export interface ListingDrawerState {
  readonly open: boolean;
  readonly list: any[];
  readonly listItems: any[];
  readonly factoryList: ListItemInterface[];
}
